import { TableCell, TableRow, Badge, Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui';
import { EventTypeEnum } from '@/enums';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { MoreHorizontal, Eye, Trash2 } from 'lucide-react';
import { getPhotoUrl, cn } from '@/lib/utils';
import { EVENT_STATUS_CONFIG } from '@/constants';
import type { IEvent } from '@/interfaces';
import EventPrice from './EventPrice';

type TProps = {
	event: IEvent;
	onDelete: (event: IEvent) => void;
	onViewDetails: (event: IEvent) => void;
	canDelete: boolean;
};

const getTypeBadge = (type: EventTypeEnum) => {
	const labels: Record<EventTypeEnum, string> = {
		[EventTypeEnum.BLIND_DATING]: 'Blind Dating',
	};
	return <Badge variant="outline">{labels[type]}</Badge>;
};

const DataTableDesktopRow = ({ event, onDelete, onViewDetails, canDelete }: TProps) => {
	return (
		<TableRow className="cursor-pointer" onClick={() => onViewDetails(event)}>
			<TableCell>
				<img src={getPhotoUrl(event.bannerImage)} alt={event.title.fr} className="h-12 w-16 object-cover rounded" />
			</TableCell>
			<TableCell className="font-medium">{event.title.fr}</TableCell>
			<TableCell>{getTypeBadge(event.type)}</TableCell>
			<TableCell>
				<Badge className={cn('text-xs font-medium', EVENT_STATUS_CONFIG[event.status].className)}>
					{EVENT_STATUS_CONFIG[event.status].label}
				</Badge>
			</TableCell>
			<TableCell className="text-sm text-muted-foreground">
				{format(new Date(event.startsAt), 'dd MMM yyyy HH:mm', { locale: fr })}
			</TableCell>
			<TableCell className="text-sm text-muted-foreground">
				{format(new Date(event.endsAt), 'dd MMM yyyy HH:mm', { locale: fr })}
			</TableCell>
			<TableCell className="text-center">
				{event.metrics.registeredCount}
				{event.maxParticipants ? ` / ${event.maxParticipants}` : ''}
			</TableCell>
			<TableCell>
				<EventPrice price={event.price} />
			</TableCell>
			<TableCell className="text-right">
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="ghost" size="icon" className="h-8 w-8 cursor-pointer" onClick={e => e.stopPropagation()}>
							<MoreHorizontal className="h-4 w-4" />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="end">
						<DropdownMenuItem className="cursor-pointer" onClick={e => { e.stopPropagation(); onViewDetails(event); }}>
							<Eye className="mr-2 h-4 w-4" />
							Voir détails
						</DropdownMenuItem>
						{canDelete && (
							<>
								<DropdownMenuSeparator />
								<DropdownMenuItem className="text-destructive cursor-pointer" onClick={e => { e.stopPropagation(); onDelete(event); }}>
									<Trash2 className="mr-2 h-4 w-4" />
									Supprimer
								</DropdownMenuItem>
							</>
						)}
					</DropdownMenuContent>
				</DropdownMenu>
			</TableCell>
		</TableRow>
	);
};

export default DataTableDesktopRow;
